// Campus photo for /colleges/university-of-michigan-ann-arbor: CC BY 2.0, by Chris Rycroft, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AFront_of_Angell_Hall.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-michigan-ann-arbor/; credited under the photo.
const photo = {
    "slug": "university-of-michigan-ann-arbor",
    "alt": "Angell Hall on the University of Michigan campus in Ann Arbor",
    "src": "/colleges/university-of-michigan-ann-arbor/campus-1600.webp",
    "srcSmall": "/colleges/university-of-michigan-ann-arbor/campus-800.webp",
    "srcMid": "/colleges/university-of-michigan-ann-arbor/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-michigan-ann-arbor/og.jpg",
    "title": "Front of Angell Hall",
    "author": "Chris Rycroft",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AFront_of_Angell_Hall.jpg",
    "read": "2026-09-30"
};

export default photo;
